export default [
  {
    path: '/',
    name: 'home.index',
    component: () => import('@/views/Index.vue'),
  },
];
